/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Icon/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import No from 'DesignSystem/VideoRecorderNative/No/index'
import React from 'react'
import Tysiav2BoardsClipboardIcon from './Tysiav2BoardsClipboardIcon/index'
import Tysiav2ClockInTaskIcon from './Tysiav2ClockInTaskIcon/index'
import Tysiav2FinanceTaskIcon from './Tysiav2FinanceTaskIcon/index'
import Tysiav2ImageTaskIcon from './Tysiav2ImageTaskIcon/index'
import Tysiav2LetterTaskIcon from './Tysiav2LetterTaskIcon/index'
import Tysiav2MedicalHistoryTaskIcon from './Tysiav2MedicalHistoryTaskIcon/index'
import Tysiav2MedicalTaskIcon from './Tysiav2MedicalTaskIcon/index'
import Tysiav2PatientTaskIcon from './Tysiav2PatientTaskIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Icon({
  children,
  viewPath = "/DesignSystem/TaskBoardIcon/Icon",
  height,
  width
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let iconIconValueData = fromData.useDataValue({ viewPath,
context: 'icon',
path: 'icon',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: iconIconValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Tysiav2BoardsClipboardIcon'}>
<Tysiav2BoardsClipboardIcon
  viewPath={`${viewPath}/Tysiav2BoardsClipboardIcon`}
 height={height}
 width={width}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Tysiav2MedicalTaskIcon'}>
<Tysiav2MedicalTaskIcon
  viewPath={`${viewPath}/Tysiav2MedicalTaskIcon`}
 height={height}
 width={width}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Tysiav2ClockInTaskIcon'}>
<Tysiav2ClockInTaskIcon
  viewPath={`${viewPath}/Tysiav2ClockInTaskIcon`}
 height={height}
 width={width}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Tysiav2LetterTaskIcon'}>
<Tysiav2LetterTaskIcon
  viewPath={`${viewPath}/Tysiav2LetterTaskIcon`}
 height={height}
 width={width}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Tysiav2PatientTaskIcon'}>
<Tysiav2PatientTaskIcon
  viewPath={`${viewPath}/Tysiav2PatientTaskIcon`}
 height={height}
 width={width}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Tysiav2ImageTaskIcon'}>
<Tysiav2ImageTaskIcon
  viewPath={`${viewPath}/Tysiav2ImageTaskIcon`}
 height={height}
 width={width}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Tysiav2MedicalHistoryTaskIcon'}>
<Tysiav2MedicalHistoryTaskIcon
  viewPath={`${viewPath}/Tysiav2MedicalHistoryTaskIcon`}
 height={height}
 width={width}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Tysiav2FinanceTaskIcon'}>
<Tysiav2FinanceTaskIcon
  viewPath={`${viewPath}/Tysiav2FinanceTaskIcon`}
 height={height}
 width={width}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}